<div class="tree-node" *q9Screenshot="scrConfig">
  <span>
    <span class="level">{{ level }}</span>
    <span class="name">{{ node.name | htmlEncoder: true }}</span>
    <span class="c-count" *ngIf="node.childCount">
      ({{ node.childCount }}&nbsp;{{ node.childCount > 1 ? 'drilldowns' : 'drilldown' }})
    </span>
  </span>
</div>
